import React from 'react'
import { InputContainer } from '../../../../../common/components/form/form.module'


export default function AddNewForumPost({ Close
    , mentors, handleItemSubmit, selectedForumPosts, onInnerBasicFormChange }: any) {


    return (

        <div className="  w-full p-2 bg-white shadow-md rounded-md">
            <h1 className="text-xl font-bold mb-4 text-center">Add Forum Posts</h1>
            <div className=" grid md:grid-cols-2 lg:grid-cols-3 gap-4 border p-4">
                  <div className='col-span-full'>
                <InputContainer
                    label="Text"
                    name="Text"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event,
                            'Text',
                        )
                    }}
                    type="rte"
                    value={selectedForumPosts?.Text}
                />
                </div>

               
               

                    
            </div>

            <div className="flex justify-end mt-6">
                <button
                    onClick={Close}
                    type="button"
                    className="m-2 bg-blue-900 text-white rounded font-medium px-4 py-3"
                >
                    Close
                </button>
                <button
                    className="m-2 bg-blue-900 text-white rounded font-medium px-4 py-3"
                    onClick={handleItemSubmit}
                    type="submit"
                >
                    Save
                </button>
            </div>

        </div>



    )
}